import { ref } from '@vue/composition-api'

import ImageWrapper from '@/components/ImageWrapper/ImageWrapper'
import PageProgress from '@/components/PageProgress/PageProgress'

import selectProps from '@/utils/selectPropertiesFromModels'

export default ({
  components: { ImageWrapper, PageProgress },
  setup(props, context) {
    const { $route, $store } = context.root
    const { slug } = $route.params

    const loading = ref(true)
    const model = ref()
    const kind = ref()
    const properties = ref([])

    const fetch = async () => {
      loading.value = true
      const data = await $store.dispatch('data/fetchModel', slug)
      loading.value = false

      model.value = data.model
      kind.value = data.kind
      properties.value = selectProps({ model: data.model, properties: data.properties })
    }

    fetch()

    return {
      loading,
      model,
      kind,
      properties,
    }
  },
})
